<template>
    <rkm-modal
        :title="`Configuração de procedimento padrão - ${item && item.ocupacaoCodigo} - ${item && item.nome}`"
        extra-large
        ref="RkmModal"
    >
        <rkm-form
            ref="RkmForm"
            show-legend
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-input-autocomplete
                        :repository="repositories.procedimento"
                        :request-query-string-params="requestQueryStringParams"
                        :search-fields="searchFields"
                        :text-field="(item) => `${formatProcedimento(item.codigo)} - ${item.nome}`"
                        :validations="validations.procedimento"
                        label="Procedimento"
                        v-model="model.procedimento"
                    />
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        @click="include"
                        color="primary"
                    >
                        Incluir
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        @click="clean"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-row>
            <rkm-col>
                <rkm-table
                    :fields="fields"
                    :items="model.procedimentos"
                >
                    <template v-slot:cell(procedimento)="{item}">
                        {{formatProcedimento(item.codigo)}} - {{item.nome}}
                    </template>

                    <template v-slot:cell(actions)="{index}">
                        <rkm-button
                            @click="destroy(index)"
                            color="danger"
                            small
                            title="Excluir"
                        >
                            <rkm-icon icon="trash" />
                        </rkm-button>
                    </template>
                </rkm-table>
            </rkm-col>
        </rkm-row>

        <template v-slot:footer="{ cancel }">
            <rkm-button @click="cancel">
                Cancelar
            </rkm-button>

            <rkm-button
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {error, object, repository, stringCase, formats} from '@/mixins'

export default {
    computed: {
        requestQueryStringParams() {
            return this.item
                ? {only_without_cid: true, cbo: this.item.ocupacaoCodigo}
                : null
        },
        searchFields() {
            return [
                {key: 'procedimento.codigo', searchable: true},
                {key: 'procedimento.nome', searchable: true},
            ]
        },
        validations() {
            return {
                procedimento: {required: true},
            }
        },
    },
    created() {
        this.repositories = {
            procedimento: this.getConectaSusRepository('sigtap.procedimento'),
        }
    },
    data: () => ({
        fields: [
            {key: 'procedimento', label: 'Procedimento', sortable: true},
            {class: 'col-min text-center', key: 'actions', label: 'Ações'},
        ],
        item: null,
        model: {
            procedimento: null,
            procedimentos: [],
        },
    }),
    methods: {
        open(item) {
            this.resetForm()

            this.item = item

            this.model.procedimentos = this.clone(item.procedimentos)

            this.$refs.RkmModal.show()
        },
        store() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    if (this.model.procedimentos && this.model.procedimentos.find(procedimento => procedimento.codigo === this.model.procedimento.codigo)) {
                        this.showValidationNotification('O procedimento já foi incluído.')
                        return
                    }

                    this.model.procedimentos.push({
                        codigo: this.model.procedimento.codigo,
                        nome: this.model.procedimento.nome,
                    })

                    this.resetForm()
                })
        },
        include() {
            this.store()
        },
        destroy(index) {
            this.showDeleteConfirmation('Deseja realmente excluir o procedimento?', async () => {
                this.model.procedimentos.splice(index, 1)
            })
        },
        save() {
            this.item.procedimentos = this.model.procedimentos

            this.$refs.RkmModal.hide()
        },
        clean() {
            this.resetForm()
        },
        resetForm() {
            this.model.procedimento = null

            this.$nextTick().then(() => this.$refs.RkmForm.resetValidator())
        },
    },
    mixins: [error, object, repository, stringCase, formats],
}
</script>